<template>
    <div>
        <Toolbar>
            <!-- LEFT -->
            <BackButton :to="__('general.brands')" :href="$route('brands.index')"/>
        </Toolbar>

        <Card>
            <form>
                <FormGroupNew label="Der Name der Marke"
                              description="Bitte vergewissern Sie sich, dass der Name korrekt geschrieben ist"
                              :error="newBrand.errors.name"
                              required
                >
                    <input type="text"
                           class="form-control"
                           :placeholder="__('general.brand')"
                           v-model="newBrand.name"
                           @keyup="updateSlug">
                </FormGroupNew>

                <FormGroupNew label="" v-if="brand.uuid === undefined">
                    <button class="btn btn-primary"
                            :disabled="!newBrand.isDirty"
                            @click="submit"
                    >
                        <i class="fas fa-plus-square"/>
                        Marke erstellen
                    </button>
                </FormGroupNew>
                <div class="card card-custom bg-success" v-else>
                    <div class="card-header border-0">
                        <div class="card-title">
                    <span class="card-icon">
                        <i class="fas fa-info-circle text-white"></i>
                    </span>
                            <h3 class="card-label text-white">Die Marke existiert bereits</h3>
                        </div>
                    </div>
                    <div class="separator separator-solid separator-white opacity-20"></div>
                    <div class="card-body text-white">
                        <div class="row">
                            <div class="col-sm-12 col-xl-8 text-center text-xl-left">
                                <h1 class="m-0">{{ brand.name }}</h1>
                                <strong>
                                    UUID: {{ brand.uuid }}<br>
                                    SLUG: {{ brand.slug }}
                                </strong>
                                <p class="pt-3 mb-0" v-if="brand.description.length > 0"
                                   v-html="brand.description"></p>
                                <p class="pt-3 mb-0" v-else>No description available</p>
                            </div>
                            <div class="col-sm-12 col-xl-4">
                                <div v-if="brand.logo !== null">
                                    <div class="pl-5 text-center text-xl-right">
                                        <img class="logo-preview" :src="brand.logo" :alt="brand.name + ' Logo'">
                                    </div>
                                </div>
                                <div v-else class="text-right">
                                    <div class="p-4 border-white rounded border d-inline-block">
                                        No Logo
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="canUpdateBrands" class="card-footer text-white">
                        <a :href="$route('brands.edit', {brandUuid: brand.uuid})" class="btn btn-white"
                           type="button"><i
                            class="fas fa-edit"></i> Edit</a>
                    </div>
                </div>
            </form>
        </Card>
    </div>
</template>

<script>
import Toolbar from '@components/Toolbar.vue'
import ToolbarLink from '@components/ToolbarLink.vue'
import BackButton from '@components/BackButton.vue'
import Card from '@components/Cards/Card.vue'
import FormGroupNew from "@components/Form/FormGroupNew.vue";

export default {
    components: {FormGroupNew, Card, BackButton, ToolbarLink, Toolbar},

    props: {
        canUpdateBrands: Boolean,
    },

    data() {
        return {
            brand: {},
            loading: false,
            newBrand: this.$inertia.form({
                name: this.brandName,
                slug: '',
            })
        }
    },

    methods: {
        updateSlug() {
            if (this.newBrand.name.trim().length === 0) {
                this.brand = {}
                this.newBrand.slug = ''
                return
            }

            this.newBrand.slug = this.$slugify(this.newBrand.name)
            this.checkForExistingBrand()
        },

        submit() {
            this.newBrand.post(this.$route('brands.store'));
        },

        async checkForExistingBrand() {
            let {data} = await axios.get(this.$route('brand.by_slug') + '?slug=' + encodeURIComponent(this.newBrand.slug))
            this.brand = data.data
        }
    },
}
</script>

<style scoped>
.logo-preview {
    max-height: 200px;
}
</style>
